import React from "react";
import PropTypes from "prop-types";
import { Grid, Link, Paper } from "@material-ui/core";
import { Typography } from "@invosys/invosys-ui";
import { Adjust } from "@material-ui/icons";
import { iconMap } from "./iconMap";
import Avatar from "./Avatar";

const Horizontal = (props) => {
  const { links } = props;
  return (
    <Paper square={true} elevation={23} style={{ margin: 0 }}>
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid item>
          <img
            src={props.imagePath}
            alt="CompanyLogo"
            style={{ maxWidth: "150px", maxHeight: "69px", margin: "8px" }}
          />
        </Grid>

        {links
          .sort((a, b) => a.index - b.index)
          .map((link, idx) => {
            const LinkIcon = iconMap[link.title] || Adjust;
            return (
              <Grid item key={`${link.index}_${idx}`}>
                <Link href={link.link} style={{ textDecoration: "none" }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                    }}
                  >
                    <LinkIcon color="primary" />
                  </div>
                  <span
                    style={{
                      textAlign: "center",
                    }}
                  >
                    <Typography color="textPrimary">{link.title}</Typography>
                  </span>
                </Link>
              </Grid>
            );
          })}

        <Grid
          item
          style={{
            display: "flex",
            justifyContent: "flex-end",
            paddingRight: "8px",
          }}
        >
          <Avatar namePlacement="bottom" />
        </Grid>
      </Grid>
    </Paper>
  );
};

Horizontal.propTypes = {
  jwt: PropTypes.string,
  links: PropTypes.array,
  imagePath: PropTypes.string,
};
export default Horizontal;
